import React from "react"

import { ReactComponent as IconX } from "@common_assets/svg/cross.svg"
import { Box, Divider, Stack, Typography } from "@mui/material"
import { HrStudentShort } from "api/reactQuery/queries/hr.types"
import { useDrag } from "react-dnd"
import { useTranslation } from "react-i18next"
import { unstyledButtonSx } from "styles/common/button"

import { DraggingBoxStyle } from "../draggableUser/DraggableUser.style"

interface IBunchUsers {
  checkedUsers: HrStudentShort[]
  onClickX: () => void
}

const BunchUsers = ({ checkedUsers, onClickX }: IBunchUsers) => {
  const { t } = useTranslation()
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "bunch",
      item: { user: checkedUsers },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [checkedUsers]
  )

  return (
    <DraggingBoxStyle
      ref={drag}
      isdragging={isDragging}
      isbunch={true}
      sx={{ p: 2, width: "100%" }}
    >
      <Stack>
        <Typography
          textAlign="start"
          fontWeight="500"
          variant="body2"
          component="h3"
        >
          {t("jobs.hireMultipleStudentsAtOnce")}:
          <Divider sx={{ width: "100%", my: "10px" }} />
        </Typography>
        <Typography sx={{ textAlignLast: "left" }}>
          <Typography
            variant="body2"
            component="span"
            sx={{
              pl: "10px",
            }}
          >
            {t("jobs.selected")} : {checkedUsers.length}
          </Typography>
        </Typography>
        <Divider sx={{ width: "100%", my: "10px" }} />
        <Typography fontWeight="500" variant="body2">
          {t("jobs.dragFromHereToHire")}
        </Typography>
      </Stack>
      <Box
        component="button"
        type="button"
        aria-label={t("jobs.clearSelectedStudents")}
        onClick={onClickX}
        sx={(theme) => ({
          ...unstyledButtonSx,
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: "3",
          ":hover": {
            transition: "color 0.3s",
            color: theme.palette.mockup.error50,
          },
        })}
      >
        <IconX />
      </Box>
    </DraggingBoxStyle>
  )
}
export default BunchUsers
